/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { CaseManagementUserDto } from './case-management-user-dto';
import { CustomerContactDto } from './customer-contact-dto';
import { ActorDto } from './actor-dto';
import { ClearanceCaseReason } from '../enums/clearance-case-reason.enum';
import { ClearanceCaseStatus } from '../enums/clearance-case-status.enum';
import { ClearanceCaseCustomerStatus } from '../enums/clearance-case-customer-status.enum';
import { TransportType } from '../enums/transport-type.enum';
import { TransitType } from '../transits/enums/transit-type.enum';
import { ImportExportCountry } from '../enums/import-export-country.enum';
import { ClearanceCaseLogDto } from './clearance-case-log-dto';
import { ExportLogEntryDto } from './export-log-entry-dto';
import { DocumentDto } from './document-dto';
import { ClearanceCaseCustomsDocumentDto } from './clearance-case-customs-document-dto';
import { CurrencyDto } from './currency-dto';
import { DeliveryConditionDto } from './delivery-condition-dto';
import { DocumentDeliveryMethod } from '../enums/document-delivery-method.enum';
import { ContainerLoad } from '../enums/container-load.enum';
import { NorwegianTaxPayerType } from '../enums/norwegian-tax-payer-type.enum';
import { SwedishTaxPayerType } from '../enums/swedish-tax-payer-type.enum';
import { PackageCategoryDto } from './package-category-dto';
import { ClearanceCaseInvoiceDto } from './clearance-case-invoice-dto';
import { ClearanceCaseRowDataDto } from './clearance-case-row-data-dto';
import { GoodsLocationType } from '../enums/goods-location-type.enum';
import { DelegateType } from '../enums/delegate-type.enum';
import { CaseEditTimeMonitorLogEntryDto } from './case-edit-time-monitor-log-entry-dto';
import { InvoiceDataDto } from '../financials/models/invoice-data-dto';
import { CaseDto } from './case-dto';
import { ClearanceCaseDocumentDto } from './clearance-case-document-dto';
import { ClearanceCaseAuthorisationDto } from './clearance-case-authorisation-dto';
import { ClearanceCaseAdditionDeductionDto } from './clearance-case-addition-deduction-dto';

//<custom-head>
import { MessageDto } from '../models/message-dto';
import { orderBy, filter, flatMap, flatten, find } from 'lodash-es';
import { parseDate, Utils, formattedDate, IconUtils } from 'app/utils';
import { toZonedTime, fromZonedTime } from 'date-fns-tz';
import { environment } from 'environments/environment';
import {
  differenceInMinutes,
  format,
  isToday,
  isTomorrow,
  isBefore
} from 'date-fns';
import { TransportTypeLookup, Translations } from 'app/translations';
import { DocumentType } from '../enums/document-type.enum';
import { FormLike } from 'cases/form-rules';
import { AbstractControl } from '@angular/forms';
import { TimeMonitorEntryType } from 'api/enums';
//</custom-head>

export class ClearanceCaseDto {
  public id: string = undefined;
  public mainCaseId: string = undefined;
  public caseId: string = undefined;
  public companyId: string = undefined;
  public caseManagerId: string = undefined;
  public companyName: string = undefined;
  public creator: CaseManagementUserDto;
  public caseManager: string = undefined;
  public contact: CustomerContactDto;
  public caseNumber: number = undefined;
  public messagesCount: number = undefined;
  public hasUnreadMessages: boolean;
  public isRegistration: boolean;
  public receiver: ActorDto;
  public receiverId: string = undefined;
  public sender: ActorDto;
  public senderId: string = undefined;
  public declarant: ActorDto;
  public declarantId: string = undefined;
  public exporterId: string = undefined;
  public importerId: string = undefined;
  public consolidatorId: string = undefined;
  public shipperId: string = undefined;
  public manufacturerId: string = undefined;
  public warehouseOwnerId: string = undefined;
  public guaranteeId: string = undefined;
  public customsPayerId: string = undefined;
  public sellerId: string = undefined;
  public buyerId: string = undefined;
  public reference: string = undefined;
  public reason: ClearanceCaseReason;
  public overrideImportDeclarationType: boolean;
  public overrideExportDeclarationType: boolean;
  public importDeclarationId: number = undefined;
  public exportDeclarationId: number = undefined;
  public importDeclarationCode: string = undefined;
  public exportDeclarationCode: string = undefined;
  public ecomId: string = undefined;
  public status: ClearanceCaseStatus;
  public customerStatus: ClearanceCaseCustomerStatus;
  public transportType: TransportType;
  public transitType: TransitType;
  public importCountry: ImportExportCountry;
  public isEuClearance: boolean;
  public exportCountry: ImportExportCountry;
  public log: ClearanceCaseLogDto[];
  public exportLog: ExportLogEntryDto[];
  public documents: DocumentDto[];
  public customsDocuments: ClearanceCaseCustomsDocumentDto[];
  public departureUtc: Date | string;
  public departureTimeKnown: boolean;
  public createdUtc: Date | string;
  public modifiedUtc: Date | string;
  public modificationsUtc: Date[];
  public customsOfficeIdEu: string = undefined;
  public customsOfficeIdNo: string = undefined;
  public noExpUnitId: string = undefined;
  public igNumber: string = undefined;
  public goodsNumber: string = undefined;
  public positionNumber: string = undefined;
  public transitDepartureOffice: string = undefined;
  public transitDestinationOffice: string = undefined;
  public transitOffices: string[];
  public invoiceValue: number = undefined;
  public invoiceCurrency: CurrencyDto;
  public invoiceCurrencyCode: string = undefined;
  public deliveryCondition: DeliveryConditionDto;
  public deliveryConditionCode: string = undefined;
  public deliveryConditionLocation: string = undefined;
  public deliveryConditionLocationCode: string = undefined;
  public deliveryConditionCountryCode: string = undefined;
  public deliveryCost: number = undefined;
  public deliveryCostAir: number = undefined;
  public deliveryCostEu: number = undefined;
  public deliveryCostNonEu: number = undefined;
  public airFreightZone: string = undefined;
  public deliveryCurrency: CurrencyDto;
  public deliveryCurrencyCode: string = undefined;
  public documentDeliveryMethod: DocumentDeliveryMethod;
  public documentDeliveryEmail: string = undefined;
  public documentDeliveryPhoneNumber: string = undefined;
  public documentDeliveryFaxNumber: string = undefined;
  public bookingNumberSe: string = undefined;
  public bookingNumberNo: string = undefined;
  public trailer: string = undefined;
  public netWeight: number = undefined;
  public netWeightFromRows: boolean;
  public grossWeight: number = undefined;
  public grossWeightFromRows: boolean;
  public packageCount: number = undefined;
  public containerLoad: ContainerLoad;
  public containerNumbers: string[];
  public controlNumber: number = undefined;
  public norwegianImportTaxPayerType: NorwegianTaxPayerType;
  public norwegianExportTaxPayerType: NorwegianTaxPayerType;
  public swedishImportTaxPayerType: SwedishTaxPayerType;
  public swedishExportTaxPayerType: SwedishTaxPayerType;
  public packageCategoryCode: string = undefined;
  public packageCategory: PackageCategoryDto;
  public masterAirWaybill: string = undefined;
  public houseAirWaybill: string = undefined;
  public invoices: ClearanceCaseInvoiceDto[];
  public rows: ClearanceCaseRowDataDto[];
  public tollPayingOrganizationNumber: string = undefined;
  public tollPayingOrganizationVatNumber: string = undefined;
  public urgent: boolean;
  public dataVersion: number = undefined;
  public dataCreatedBy: string = undefined;
  public dataCreatedUtc: Date | string;
  public siblings: ClearanceCaseDto[];
  public slaStartDate: Date | string;
  public slaHoursUntilDate: string = undefined;
  public slaHoursUntilDateFormatted: string = undefined;
  public transportTypeBorderSeId: number = undefined;
  public transportTypeBorderNoId: number = undefined;
  public transportTypeInlandSeId: number = undefined;
  public transportTypeInlandNoId: number = undefined;
  public transactionTypeSeImportId: number = undefined;
  public transactionTypeNoImportId: number = undefined;
  public transactionTypeSeExportId: number = undefined;
  public transactionTypeNoExportId: number = undefined;
  public transportIdentityArrival: string = undefined;
  public transportIdentityArrivalCountryCode: string = undefined;
  public transportIdentityBorder: string = undefined;
  public transportIdentityBorderCountryCode: string = undefined;
  public loadingLocationCode: string = undefined;
  public goodsLocationTypeSe: GoodsLocationType;
  public goodsLocalTypeSe: string = undefined;
  public goodsLocationCustomsOfficeSe: string = undefined;
  public goodsLocalCodeSe: string = undefined;
  public goodsLocationSe: string = undefined;
  public goodsLocationNo: string = undefined;
  public senderCountryCode: string = undefined;
  public recipientCountryCode: string = undefined;
  public administrativeUnitId: number = undefined;
  public delegateType: DelegateType;
  public delegateId: number = undefined;
  public caseEditTimeMonitorLogEntries: CaseEditTimeMonitorLogEntryDto[];
  public autoDistributedPackageCount: boolean;
  public invoiceData: InvoiceDataDto[];
  public invoiceDataLocked: boolean;
  public invoiced: boolean;
  public exportLocked: boolean;
  public mainCase: CaseDto;
  public needsCalculation: boolean;
  public earlierDocuments: ClearanceCaseDocumentDto[];
  public additionalInformationDocuments: ClearanceCaseDocumentDto[];
  public additionalReferenceInformationDocuments: ClearanceCaseDocumentDto[];
  public transportDocuments: ClearanceCaseDocumentDto[];
  public supportingDocuments: ClearanceCaseDocumentDto[];
  public authorisations: ClearanceCaseAuthorisationDto[];
  public additionDeductions: ClearanceCaseAdditionDeductionDto[];

  //<custom-body>
  private _formLike: FormLike;

  public messages: MessageDto[];

  constructor(source: ClearanceCaseDto, mainCase: CaseDto) {
    Object.assign(this, source);

    this.mainCase = mainCase || null;
    this.contact = source.contact
      ? new CustomerContactDto(source.contact)
      : null;
    this.creator = source.creator
      ? new CaseManagementUserDto(source.creator)
      : null;
    this.log = orderBy(source.log || [], l => l.dateTimeUtc, 'desc').map(
      l => new ClearanceCaseLogDto(l)
    );
    this.exportLog = orderBy(
      source.exportLog || [],
      l => l.dateTimeUtc,
      'desc'
    ).map(l => new ExportLogEntryDto(l));

    this.createdUtc = parseDate(source.createdUtc);
    this.modifiedUtc = parseDate(source.modifiedUtc);
    this.departureUtc = parseDate(source.departureUtc);
    this.dataCreatedUtc = parseDate(source.dataCreatedUtc);

    this.packageCategory = source.packageCategory
      ? new PackageCategoryDto(source.packageCategory)
      : null;
    this.invoices = source.invoices
      ? source.invoices.map(i => new ClearanceCaseInvoiceDto(i))
      : null;

    this.sender = new ActorDto(source.sender);
    this.receiver = new ActorDto(source.receiver);
    this.declarant = new ActorDto(source.declarant);

    this.siblings = source.siblings
      ? source.siblings.map(s => new ClearanceCaseDto(s, mainCase))
      : [];
    this.documents = source.documents
      ? source.documents.map(s => new DocumentDto(s))
      : [];
    this.rows = source.rows || [];
    this.modificationsUtc = source.modificationsUtc || [];
    this.customsDocuments = source.customsDocuments
      ? source.customsDocuments.map(s => new ClearanceCaseCustomsDocumentDto(s))
      : [];

    this.slaStartDate = source.slaStartDate
      ? toZonedTime(source.slaStartDate, environment.timezone)
      : null;

    this.invoiceData = source.invoiceData
      ? source.invoiceData.map(invoiceData => new InvoiceDataDto(invoiceData))
      : null;
  }

  public get slaTimeLeftFormatted(): string {
    const diff = differenceInMinutes(parseDate(this.slaStartDate), new Date());
    return Utils.friendlyTimeSpan(diff);
  }

  public get isCreated(): boolean {
    return this.customerStatus === ClearanceCaseCustomerStatus.Created;
  }

  public get isRegistered(): boolean {
    const latestLog = this.latestLog();
    return (
      latestLog &&
      latestLog.customerStatus === ClearanceCaseCustomerStatus.Registered
    );
  }

  public get isCancelled(): boolean {
    const latestLog = this.latestLog();
    return latestLog && latestLog.status === ClearanceCaseStatus.Cancelled;
  }

  public get isCompleted(): boolean {
    const latestLog = this.latestLog();
    return latestLog && latestLog.status === ClearanceCaseStatus.Completed;
  }

  public get hasCaseManager(): boolean {
    return this.caseManagerId && this.caseManager !== '';
  }

  public get hasCustomer(): boolean {
    return this.mainCase && this.mainCase.customer != null;
  }

  public get hasContact(): boolean {
    return this.contact != null;
  }

  public get createdDate(): string {
    return formattedDate(toZonedTime(this.createdUtc, environment.timezone));
  }

  public get modifiedDate(): string {
    return formattedDate(
      toZonedTime(this.modifiedUtc, environment.timezone)
    );
  }

  public get dataCreatedDate(): string {
    return formattedDate(
      toZonedTime(this.dataCreatedUtc, environment.timezone)
    );
  }

  public get departureDate(): string {
    return this.departureUtc
      ? formattedDate(
          toZonedTime(this.departureUtc, environment.timezone),
          true
        )
      : '';
  }

  public get departureTime(): Date {
    return this.departureUtc
      ? toZonedTime(this.departureUtc, environment.timezone)
      : null;
  }

  public get departureTimeString(): string {
    if (!this.departureUtc) return '';

    if (!this.hasDepartureTime) return 'Inte satt';

    return `kl. ${format(
      toZonedTime(this.createdUtc, environment.timezone),
      'HH:mm'
    )}`;
  }

  public get hasDepartureTime(): boolean {
    return (
      this.departureUtc != null &&
      format(parseDate(this.departureUtc), 'HH:mm:ss') !== '12:34:56'
    );
  }

  public get transportIcon(): string {
    return IconUtils.transportIcon(this.transportType);
  }

  public get transportTypeString(): string {
    return TransportTypeLookup.translate(this.transportType);
  }

  public get messageClass(): string {
    const klasses = ['label', 'label-message'];

    if (this.mainCase && this.mainCase.messageReceivedAfterFetch != null)
      klasses.push('updated');

    if (this.hasUnreadMessages) klasses.push('label-primary');
    else klasses.push('label-default');

    return klasses.join(' ');
  }

  public get logTooltipHtml(): string {
    const entries = this.log.map(
      entry =>
        entry.logLabel + ' av ' + entry.createdBy + ' - ' + entry.formattedDate
    );
    entries.unshift('STATUS LOGG');

    return entries.join('<hr/>');
  }

  public latestLog(
    filterFunc: (ClearanceCaseLogDto) => boolean = log => !log.isSystem
  ): ClearanceCaseLogDto {
    return this.log && this.log.length > 0
      ? find(this.log, log => filterFunc(log))
      : null;
  }

  public get customerLogLabelClass(): string {
    const latestLog = this.latestLog();
    return latestLog ? latestLog.customerLogLabelClass : 'label-created-ecus';
  }

  public get logLabelClass(): string {
    // FIXME: Use CaseStatus instead
    const latestLog = this.latestLog();
    return latestLog ? latestLog.logLabelClass : 'label-created-ecus';
  }

  public get caseDocuments(): DocumentDto[] {
    return orderBy(
      filter(
        this.documents,
        (d: DocumentDto) => d.type === DocumentType.CaseDocument
      ),
      d => d.modifiedUtc,
      ['desc']
    );
  }

  public get workDocuments(): DocumentDto[] {
    return orderBy(
      flatten([
        filter(
          this.documents,
          (d: DocumentDto) => d.type === DocumentType.WorkDocument
        ),
        flatMap(this.messages, (m: MessageDto) => m.documents)
      ]),
      d => d.modifiedUtc,
      ['desc']
    );
  }

  public get hasBorderCrossing(): boolean {
    return (
      (this.customsOfficeIdEu !== undefined &&
        this.customsOfficeIdEu !== null &&
        this.customsOfficeIdEu.length == 8) ||
      (this.customsOfficeIdNo !== undefined &&
        this.customsOfficeIdNo !== null &&
        this.customsOfficeIdNo.length == 6)
    );
  }

  public get hasDepartureDate(): boolean {
    return this.departureUtc != null;
  }

  public get hasTransit(): boolean {
    return this.transitType != null && this.transitType !== TransitType.None;
  }

  public get hasInvoices(): boolean {
    return this.invoices && this.invoices.length > 0;
  }

  public get documentDelivery(): string {
    const flags = [];

    // tslint:disable:no-bitwise
    for (const method in DocumentDeliveryMethod) {
      if (isNaN(Number(method))) {
        const m = Number(DocumentDeliveryMethod[method]);
        if (this.documentDeliveryMethod & m)
          flags.push(Translations.DocumentDeliveryMethod[method]);
      }
    }
    // tslint:enable:no-bitwise

    return flags.join(', ');
  }

  // tslint:disable:no-bitwise
  public get hasDocumentDeliveryEmail(): boolean {
    return !!(this.documentDeliveryMethod & DocumentDeliveryMethod.Email);
  }

  public get hasDocumentDeliverySms(): boolean {
    return !!(this.documentDeliveryMethod & DocumentDeliveryMethod.Sms);
  }

  public get hasDocumentDeliveryFax(): boolean {
    return !!(this.documentDeliveryMethod & DocumentDeliveryMethod.Fax);
  }

  public get hasDocumentDeliveryPickup(): boolean {
    return !!(this.documentDeliveryMethod & DocumentDeliveryMethod.Pickup);
  }

  public get hasDocumentDeliveryNotSet(): boolean {
    return this.documentDeliveryMethod === DocumentDeliveryMethod.None;
  }
  // tslint:enable:no-bitwise

  public get asFormLike(): FormLike {
    if (!this._formLike) {
      this._formLike = {
        value: Object.assign({}, this) as any
      };
      this._formLike.value.deliveryCondition = [{ id: this.deliveryCondition }];
      this._formLike.value.clearanceType = {
        importType: { id: this.importCountry },
        exportType: { id: this.exportCountry },
        transitType: { id: this.transitType }
      };
      this._formLike.get = (key: string) => {
        if (key.indexOf('clearanceType.') > -1)
          return {
            value: this._formLike.value.clearanceType[key.substring(14)]
          } as AbstractControl;

        return { value: this._formLike.value[key] } as AbstractControl;
      };
    }

    return this._formLike;
  }

  public get processing(): boolean {
    const latestLog = this.latestLog();
    return (
      latestLog &&
      latestLog.customerStatus === ClearanceCaseCustomerStatus.Processing
    );
  }

  private get hasSiblingCases(): boolean {
    return this.siblings && this.siblings.length > 0;
  }

  public get SumEditTimeString(): string {
    const startlogs = this.caseEditTimeMonitorLogEntries.filter(
      ce => ce.entryType === TimeMonitorEntryType.Start
    );
    const stoplogs = this.caseEditTimeMonitorLogEntries.filter(
      ce => ce.entryType === TimeMonitorEntryType.Stop
    );
    let output = 0;

    for (const i in stoplogs) {
      const st = +Date.parse(stoplogs[i].timeStampUtc.toString());
      const start = +Date.parse(startlogs[i].timeStampUtc.toString());
      output = output + (st - start);
    }

    if (startlogs.length > stoplogs.length) {
      output +=
        +new Date() -
        +Date.parse(startlogs[startlogs.length - 1].timeStampUtc.toString());
    }

    return Math.round(output / 60000).toString();
  }
  //</custom-body>
}
